import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { riderLabel, searchRiders } from "./collectMoneyData";

const SEARCH_DELAY_MS = 300;

export default function RiderPicker({ value, onChange }) {
  const [text, setText] = useState("");
  const [riders, setRiders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let live = true;
    setLoading(true);
    const timer = setTimeout(() => {
      searchRiders(text).then((rows) => {
        if (!live) return;
        setRiders(rows);
        setLoading(false);
      });
    }, SEARCH_DELAY_MS);
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, [text]);

  return (
    <label className="rider-form__field collect-money__rider">
      <span className="stl-field__label">Rider</span>
      <Select
        showSearch
        value={value}
        placeholder="Search by name, mobile or ID"
        filterOption={false}
        onSearch={setText}
        onChange={onChange}
        loading={loading}
        notFoundContent={loading ? "Searching…" : "No rider found"}
        options={riders.map((rider) => ({ value: rider.id, label: riderLabel(rider) }))}
        style={{ width: "100%" }}
        aria-label="Rider"
      />
    </label>
  );
}
